/* Domovoi · "Put Domovoi on your home screen" (D1.2), on the signed-in home hub.

   A quiet card under the greeting, never a popup. Phones and tablets only, never
   inside the installed app, and gone for good on this device once dismissed.
   Android (Chrome, Edge, Samsung): one tap, through the browser's own install
   prompt that src/core/pwa.js keeps hold of. Elsewhere it shows the steps for
   that browser. The hub redraws itself, so the card re-attaches after each draw.

   Reaches the PWA layer through window.DVPwa (site.js), not by import: this file
   is in home.js, a separate bundle, and an import would be a second copy. */
var DISMISS_KEY = 'domovoi.install.dismissed';
var ICON = '/assets/icons/icon-192.png';

var SHARE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12"/><path d="m8 7 4-4 4 4"/><path d="M6 11v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8"/></svg>';
var PLUS = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="4"/><path d="M12 8v8M8 12h8"/></svg>';
var DOTS = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/></svg>';

function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
function track(action, props) { if (window.DVTrack) window.DVTrack('install_nudge', Object.assign({ product: 'account', action: action }, props || {})); }

/* Which phone and browser, for the right steps. iPadOS reports as a Mac. */
function device() {
  var ua = navigator.userAgent || '';
  var ios = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  var android = /Android/.test(ua);
  return { ios: ios, android: android, iosSafari: ios && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua), mobile: ios || android };
}

function installed() { return !!(window.DVPwa && window.DVPwa.isInstalled && window.DVPwa.isInstalled()); }
function prompt() { return window.DVPwa && window.DVPwa.installPrompt ? window.DVPwa.installPrompt() : null; }

function steps(d) {
  return (d.ios ? iosSteps(d) : androidSteps()).map(function (t, i) { return '<li><i class="n" aria-hidden="true">' + (i + 1) + '</i><span>' + t + '</span></li>'; }).join('');
}
function iosSteps(d) {
  var where = d.iosSafari ? 'at the bottom of Safari' : 'in the address bar';
  return ['Tap ' + SHARE + ' <b>Share</b> ' + where, 'Scroll down, tap ' + PLUS + ' <b>Add to Home Screen</b>', 'Tap <b>Add</b>, top right'];
}
function androidSteps() {
  return ['Tap ' + DOTS + ' the <b>menu</b> in the browser bar', 'Tap <b>Add to Home screen</b> or <b>Install app</b>', 'Tap <b>Install</b>'];
}
function card(d) {
  var oneTap = !!prompt();
  var el = document.createElement('section');
  el.className = 'h-install';
  el.setAttribute('aria-label', 'Put Domovoi on your home screen');
  el.innerHTML =
    '<img src="' + ICON + '" alt="" width="48" height="48">' +
    '<div><h2 class="t">Put Domovoi on your home screen</h2>' +
    '<p class="s">It opens like an app, and your shopping list works with no signal.</p></div>' +
    '<button type="button" class="x" aria-label="Don’t show this again">×</button>' +
    '<div class="acts"><button type="button" class="p-btn pop go">' + (oneTap ? 'Add to home screen' : 'Show me how') + '</button></div>' +
    '<ol hidden>' + steps(d) + '</ol>' +
    (d.ios ? '<p class="note" hidden>Then open it from your home screen and sign in once more: iPhone keeps the app apart from Safari.</p>' : '');

  el.querySelector('.x').addEventListener('click', function () {
    set(DISMISS_KEY, String(Date.now()));
    track('dismissed');
    el.remove();
  });
  el.querySelector('.go').addEventListener('click', function () {
    var p = prompt();
    if (p) {
      track('prompted');
      p.prompt();
      p.userChoice.then(function (c) {
        track(c && c.outcome === 'accepted' ? 'accepted' : 'declined');
        if (c && c.outcome === 'accepted') el.remove();
      }).catch(function () {});
      return;
    }
    track('steps_opened', { ios: d.ios });
    el.querySelector('.acts').hidden = true;
    el.querySelector('ol').hidden = false;
    var n = el.querySelector('.note'); if (n) n.hidden = false;
  });
  return el;
}

var shown = false;
function wanted(d) {
  // Never inside the app shell: that is the app.
  return d.mobile && !installed() && !get(DISMISS_KEY) && !document.documentElement.hasAttribute('data-shell');
}
function attach() {
  var d = device();
  // Home redrawn (the week on the web, src/home-web): the slot Home leaves under its hero on a phone
  var slot = document.getElementById('hm-install-slot');
  if (slot) {
    if (slot.firstChild || !wanted(d)) return;
    slot.appendChild(card(d));
  } else {
    var hub = document.getElementById('hub');
    var head = hub && hub.querySelector('.h-head');
    if (!head || hub.querySelector('.h-install') || !wanted(d)) return;
    head.after(card(d));
  }
  if (!shown) { shown = true; track('shown', { ios: d.ios, one_tap: !!prompt(), redesign: !!slot }); }
}

function start() {
  var hub = document.getElementById('hub');
  var web = document.getElementById('dv-home-web');
  if (!hub && !web) return;
  attach();
  if (hub) new MutationObserver(attach).observe(hub, { childList: true });
  if (web) new MutationObserver(attach).observe(web, { childList: true, subtree: true });
  // Chrome may offer its prompt after the card is drawn: switch the button over.
  window.addEventListener('dv-installable', function () {
    var b = document.querySelector('.h-install .go');
    if (b && !b.closest('.acts').hidden) b.textContent = 'Add to home screen';
  });
  window.addEventListener('appinstalled', function () {
    track('installed');
    var el = document.querySelector('.h-install'); if (el) el.remove();
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
}
